import Vue from 'vue'
import App from './App.vue'

new Vue({
  //i18n,
  render: h => h(App),
  
}).$mount('#app')
